import { Avatar, Badge } from '@mui/material';
import styled, { css } from 'styled-components';
import colors from '../../styles/colors';
import AvatarSizeType from './AvatarSizes';

const size = (avatarSize) => {
  let width;
  let height;

  switch (avatarSize) {
    case AvatarSizeType.SMALL:
      width = '36px';
      height = '36px';
      break;
    case AvatarSizeType.MEDIUM:
      width = '40px';
      height = '40px';
      break;
    case AvatarSizeType.LARGE:
      width = '60px';
      height = '60px';
      break;
    default:
      width = '40px';
      height = '40px';
  }
  return css`
    width: ${width};
    height: ${height};
  `;
};

const badgePosition = (avatarSize) => {
  let left;

  switch (avatarSize) {
    case AvatarSizeType.SMALL:
      left = '18px';
      break;
    case AvatarSizeType.MEDIUM:
      left = '20px';
      break;
    case AvatarSizeType.LARGE:
      left = '30px';
      break;
    default:
      left = '20px';
  }
  return css`
    left: ${left};
  `;
};

const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledImage = styled.img`
  ${(props) => size(props.$avatarSize)};
  border-radius: 50%;
  object-fit: cover;
`;

// Fill and text colour come from the MuiAvatar override in the CoachTools theme, so
// they are deliberately not repeated here.
const StyledAvatar = styled(Avatar)`
  ${(props) => size(props.$avatarSize)};
`;

const StyledBadge = styled(Badge)`
  margin-bottom: ${(props) => props.$showNewBadge && '8px'};
  .MuiBadge-badge {
    height: 15px;
    font-size: 10px;
    padding-top: 2px;
    background-color: ${(props) => props.$badgeColor};
    color: ${colors.base.alpha};
    ${(props) => badgePosition(props.$avatarSize)};
  }
`;

const OnlineStatus = styled.div`
  position: absolute;
  bottom: 3px;
  right: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $isOnline }) => ($isOnline ? colors.shades.success6 : colors.shades.gamma2)};
`;

export {
  AvatarWrapper,
  StyledImage,
  StyledAvatar,
  StyledBadge,
  OnlineStatus,
};
